export const categories = [
  {
    id: 'entertainment',
    name: '娱乐圈',
    slug: 'entertainment',
    description: '娱乐圈独家内幕、明星八卦、影视动态，揭秘台前幕后的真实故事',
    icon: 'ri-movie-2-line',
    color: 'primary',
  },
  {
    id: 'influencers',
    name: '网红圈',
    slug: 'influencers',
    description: '网红界最新爆料、直播内幕、人设崩塌，还原最真实的网络红人',
    icon: 'ri-live-line',
    color: 'accent',
  },
  {
    id: 'business',
    name: '商业圈',
    slug: 'business',
    description: '商业大佬内幕交易、企业黑幕、资本市场暗流涌动',
    icon: 'ri-briefcase-line',
    color: 'secondary',
  },
  {
    id: 'hot-events',
    name: '热点事件',
    slug: 'hot-events',
    description: '社会热点深度追踪、突发事件第一现场、全民关注焦点事件',
    icon: 'ri-fire-line',
    color: 'primary',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};

export const getCategoryName = (slug: string) => {
  const cat = getCategoryBySlug(slug);
  return cat ? cat.name : slug;
};